"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyEnumArray = exports.CurrencyEnum = void 0;
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["AED"] = "AED";
    CurrencyEnum["ALL"] = "ALL";
    CurrencyEnum["AMD"] = "AMD";
    CurrencyEnum["ARS"] = "ARS";
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["AZN"] = "AZN";
    CurrencyEnum["BAM"] = "BAM";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["BRL"] = "BRL";
    CurrencyEnum["BYN"] = "BYN";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CLP"] = "CLP";
    CurrencyEnum["CNY"] = "CNY";
    CurrencyEnum["COP"] = "COP";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["GEL"] = "GEL";
    CurrencyEnum["HKD"] = "HKD";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["IDR"] = "IDR";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["INR"] = "INR";
    CurrencyEnum["ISK"] = "ISK";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["KRW"] = "KRW";
    CurrencyEnum["MDL"] = "MDL";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["MYR"] = "MYR";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["NZD"] = "NZD";
    CurrencyEnum["OMR"] = "OMR";
    CurrencyEnum["PHP"] = "PHP";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["QAR"] = "QAR";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["RSD"] = "RSD";
    CurrencyEnum["RUB"] = "RUB";
    CurrencyEnum["SAR"] = "SAR";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["TRY"] = "TRY";
    CurrencyEnum["TWD"] = "TWD";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["ZAR"] = "ZAR";
    CurrencyEnum["UGX"] = "UGX";
    CurrencyEnum["KES"] = "KES";
    CurrencyEnum["MUR"] = "MUR";
    CurrencyEnum["NGN"] = "NGN";
    CurrencyEnum["CRC"] = "CRC";
    CurrencyEnum["MKD"] = "MKD";
    CurrencyEnum["XOF"] = "XOF";
    CurrencyEnum["BWP"] = "BWP";
    CurrencyEnum["VND"] = "VND";
    CurrencyEnum["RWF"] = "RWF";
    CurrencyEnum["TND"] = "TND";
    CurrencyEnum["GHS"] = "GHS";
    CurrencyEnum["AFN"] = "AFN";
    CurrencyEnum["BDT"] = "BDT";
    CurrencyEnum["BHD"] = "BHD";
    CurrencyEnum["BIF"] = "BIF";
    CurrencyEnum["BND"] = "BND";
    CurrencyEnum["BOB"] = "BOB";
    CurrencyEnum["BZD"] = "BZD";
    CurrencyEnum["CDF"] = "CDF";
    CurrencyEnum["CVE"] = "CVE";
    CurrencyEnum["DJF"] = "DJF";
    CurrencyEnum["DOP"] = "DOP";
    CurrencyEnum["DZD"] = "DZD";
    CurrencyEnum["EGP"] = "EGP";
    CurrencyEnum["ERN"] = "ERN";
    CurrencyEnum["ETB"] = "ETB";
    CurrencyEnum["GNF"] = "GNF";
    CurrencyEnum["GTQ"] = "GTQ";
    CurrencyEnum["HNL"] = "HNL";
    CurrencyEnum["IQD"] = "IQD";
    CurrencyEnum["IRR"] = "IRR";
    CurrencyEnum["JMD"] = "JMD";
    CurrencyEnum["JOD"] = "JOD";
    CurrencyEnum["KHR"] = "KHR";
    CurrencyEnum["KMF"] = "KMF";
    CurrencyEnum["KWD"] = "KWD";
    CurrencyEnum["KZT"] = "KZT";
    CurrencyEnum["LBP"] = "LBP";
    CurrencyEnum["LKR"] = "LKR";
    CurrencyEnum["LYD"] = "LYD";
    CurrencyEnum["MAD"] = "MAD";
    CurrencyEnum["MGA"] = "MGA";
    CurrencyEnum["MMK"] = "MMK";
    CurrencyEnum["MOP"] = "MOP";
    CurrencyEnum["MZN"] = "MZN";
    CurrencyEnum["NAD"] = "NAD";
    CurrencyEnum["NIO"] = "NIO";
    CurrencyEnum["NPR"] = "NPR";
    CurrencyEnum["PAB"] = "PAB";
    CurrencyEnum["PEN"] = "PEN";
    CurrencyEnum["PKR"] = "PKR";
    CurrencyEnum["PYG"] = "PYG";
    CurrencyEnum["SDG"] = "SDG";
    CurrencyEnum["SOS"] = "SOS";
    CurrencyEnum["SYP"] = "SYP";
    CurrencyEnum["TOP"] = "TOP";
    CurrencyEnum["TTD"] = "TTD";
    CurrencyEnum["TZS"] = "TZS";
    CurrencyEnum["UYU"] = "UYU";
    CurrencyEnum["UZS"] = "UZS";
    CurrencyEnum["XAF"] = "XAF";
    CurrencyEnum["YER"] = "YER";
    CurrencyEnum["ZWL"] = "ZWL";
    CurrencyEnum["ANG"] = "ANG";
    CurrencyEnum["AOA"] = "AOA";
    CurrencyEnum["AWG"] = "AWG";
    CurrencyEnum["BBD"] = "BBD";
    CurrencyEnum["BMD"] = "BMD";
    CurrencyEnum["BSD"] = "BSD";
    CurrencyEnum["BTN"] = "BTN";
    CurrencyEnum["CLF"] = "CLF";
    CurrencyEnum["CUC"] = "CUC";
    CurrencyEnum["CUP"] = "CUP";
    CurrencyEnum["FJD"] = "FJD";
    CurrencyEnum["FKP"] = "FKP";
    CurrencyEnum["GIP"] = "GIP";
    CurrencyEnum["GMD"] = "GMD";
    CurrencyEnum["GYD"] = "GYD";
    CurrencyEnum["HTG"] = "HTG";
    CurrencyEnum["KGS"] = "KGS";
    CurrencyEnum["KPW"] = "KPW";
    CurrencyEnum["KYD"] = "KYD";
    CurrencyEnum["LAK"] = "LAK";
    CurrencyEnum["LRD"] = "LRD";
    CurrencyEnum["LSL"] = "LSL";
    CurrencyEnum["MNT"] = "MNT";
    CurrencyEnum["MRU"] = "MRU";
    CurrencyEnum["MVR"] = "MVR";
    CurrencyEnum["MWK"] = "MWK";
    CurrencyEnum["PGK"] = "PGK";
    CurrencyEnum["SBD"] = "SBD";
    CurrencyEnum["SCR"] = "SCR";
    CurrencyEnum["SHP"] = "SHP";
    CurrencyEnum["SLL"] = "SLL";
    CurrencyEnum["SRD"] = "SRD";
    CurrencyEnum["SSP"] = "SSP";
    CurrencyEnum["STN"] = "STN";
    CurrencyEnum["SVC"] = "SVC";
    CurrencyEnum["SZL"] = "SZL";
    CurrencyEnum["TJS"] = "TJS";
    CurrencyEnum["TMT"] = "TMT";
    CurrencyEnum["VES"] = "VES";
    CurrencyEnum["VUV"] = "VUV";
    CurrencyEnum["WST"] = "WST";
    CurrencyEnum["XCD"] = "XCD";
    CurrencyEnum["XPF"] = "XPF";
    CurrencyEnum["ZMW"] = "ZMW";
})(CurrencyEnum || (exports.CurrencyEnum = CurrencyEnum = {}));
exports.currencyEnumArray = Object.values(CurrencyEnum);
